// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kuJ_","content":"styles_content__2RKck"};